import { render } from "./registerView.vue?vue&type=template&id=6b3a50bc&scoped=true"
import script from "./registerView.vue?vue&type=script&lang=js"
export * from "./registerView.vue?vue&type=script&lang=js"

import "./registerView.vue?vue&type=style&index=0&id=6b3a50bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3a50bc"]])

export default __exports__